import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
import { spacing } from "../../util/spacing";
import mediaQueries from "../../util/mediaqueries";
import styled, { css } from 'styled-components';
import Headline, { SIZE as HeadlineSize } from "../typography/headline/next";
import Text, { SIZE as TextSize } from "../typography/text/next";
import Grid from "../grid-container/next";
import { CopyVariant, Variant } from "./types";
import ModuleMediaContainer from "../module-media-container";
import ModuleContainer from "../module-container";
import Markdown from 'react-markdown';
export var Backdrop = styled(Grid).withConfig({
  componentId: "sc-k5cmh9-0"
})(["row-gap:0;", ""], function (_ref) {
  var hasBackdrop = _ref.hasBackdrop,
    backdropColor = _ref.backdropColor;
  return hasBackdrop && css(["background-color:", ";border-radius:64px;", " ", " ", ""], backdropColor, mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        border-radius: 72px;\n      "]))))), mediaQueries.lg(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        border-radius: 80px;\n      "]))))), mediaQueries.xl(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        border-radius: 96px;\n      "]))))));
});
export var Section = styled(ModuleContainer).withConfig({
  componentId: "sc-k5cmh9-1"
})(["", ";"], function (_ref2) {
  var variant = _ref2.variant;
  switch (variant) {
    case Variant.Compact:
      return css(["padding-bottom:", ";"], spacing(8));
    case Variant.WithBackdrop:
    case Variant.WithBackdropAndMedia:
      return css(["padding:", ";", "{padding:", ";}"], spacing(3, 2), Backdrop, spacing(8, 2));
    default:
      return css(["padding-top:", ";padding-bottom:", ";", " ", ""], spacing(8), spacing(8), mediaQueries.sm(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            padding-top: ", ";\n            padding-bottom: ", ";\n          "])), 0, 0)), spacing(10), spacing(10)), mediaQueries.md(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            padding-top: ", ";\n            padding-bottom: ", ";\n          "])), 0, 0)), spacing(12), spacing(12)));
  }
});
export var Headings = styled.div.withConfig({
  componentId: "sc-k5cmh9-2"
})(["padding:0;text-align:center;grid-column:1 / -1;margin-bottom:", ";", " ", " ", ""], spacing(5), mediaQueries.sm(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    grid-column: 2 / -2;\n  "]))))), mediaQueries.md(_t7 || (_t7 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    grid-column: 3 / -3;\n\n    ", "\n  "])), 0)), function (_ref3) {
  var alignLeft = _ref3.alignLeft,
    hasMedia = _ref3.hasMedia;
  return alignLeft && css(["grid-column:2 / 8;text-align:left;margin-bottom:", ";align-self:self-end;"], hasMedia ? spacing(5) : 0);
}), mediaQueries.xl(_t8 || (_t8 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    grid-column: 4 / -4;\n\n    ", "\n  "])), 0)), function (_ref4) {
  var alignLeft = _ref4.alignLeft;
  return alignLeft && css(["grid-column:2 / 8;text-align:left;"]);
}));
export var Heading = styled(Headline).attrs(function (_ref5) {
  var copyVariant = _ref5.copyVariant;
  return {
    element: 'h2',
    size: copyVariant === CopyVariant.Expressive ? HeadlineSize.TWO : HeadlineSize.ONE,
    smallViewportsSize: copyVariant === CopyVariant.Expressive ? HeadlineSize.THREE : HeadlineSize.ONE,
    mediumViewportsSize: copyVariant === CopyVariant.Expressive ? HeadlineSize.FOUR : HeadlineSize.TWO,
    largeViewportsSize: copyVariant === CopyVariant.Expressive ? HeadlineSize.FIVE : HeadlineSize.THREE,
    extraLargeViewportsSize: copyVariant === CopyVariant.Expressive ? HeadlineSize.FIVE : HeadlineSize.THREE
  };
}).withConfig({
  componentId: "sc-k5cmh9-3"
})(["&:not(:last-child){margin-bottom:", ";", "}"], function (_ref6) {
  var hasBackdrop = _ref6.hasBackdrop;
  return spacing(hasBackdrop ? 3 : 2);
}, mediaQueries.lg(_t9 || (_t9 = _(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n    "])), 0)), spacing(3)));
export var Subheading = styled(Text).attrs(function () {
  return {
    element: Markdown,
    size: TextSize.M,
    extraSmallViewportsSize: TextSize.S,
    smallViewportsSize: TextSize.S
  };
}).withConfig({
  componentId: "sc-k5cmh9-4"
})(["ul{list-style:none;padding:0;}p,ul{margin:", ";&:last-child{margin:0;}}"], spacing(0, 0, 1));
export var Links = styled.div.withConfig({
  componentId: "sc-k5cmh9-5"
})(["grid-column:1 / -1;grid-row:", ";", " ", ""], function (_ref7) {
  var hasHeadings = _ref7.hasHeadings;
  return hasHeadings ? 'unset' : 2;
}, mediaQueries.sm(_t10 || (_t10 = _(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    justify-self: center;\n  "]))))), function (_ref8) {
  var alignLeft = _ref8.alignLeft,
    alignRight = _ref8.alignRight;
  return css(["", ""], mediaQueries.md(_t11 || (_t11 = _(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      ", "\n\n      ", "\n    "])), 0, 0)), alignRight && css(["grid-column:-6 / -2;align-self:center;justify-self:center;"]), alignLeft && css(["grid-column:2 / 8;justify-self:left;", ""], function (_ref9) {
    var hasHeadings = _ref9.hasHeadings;
    return !hasHeadings && css(["grid-row:1 / 3;align-self:center;"]);
  })));
});
export var Media = styled(ModuleMediaContainer).withConfig({
  componentId: "sc-k5cmh9-6"
})(["grid-column:1 / -1;grid-row:", ";margin:", ";width:auto;", " ", " img{width:100%;object-fit:cover;", "}.lf-player-container{line-height:0;height:100%;display:flex;align-items:center;justify-content:center;}"], function (_ref10) {
  var hasHeadings = _ref10.hasHeadings;
  return hasHeadings ? 2 : 'unset';
}, spacing(0, -2, 5, -2), mediaQueries.sm(_t12 || (_t12 = _(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    grid-column: 3 / -3;\n    margin: ", "\n  "])), 0)), spacing(0, -3, 5, -3)), mediaQueries.md(_t13 || (_t13 = _(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    grid-column: 8 / -2;\n    grid-row: 1 / 3;\n    margin: ", ";\n  "])), 0)), spacing(-8, 0)), mediaQueries.md(_t14 || (_t14 = _(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      height: 100%;\n    "]))))));